import type { ApiResponse } from '@/shared/services/01_axios/api/response.api'
import type { UserModel } from '@/shared/types'
import type { AxiosRequestConfig } from 'axios'
import http from '../01_axios/index'
import type { LoginRequest, LoginResponse, UserExtraInfo } from './components/identity.param'
import {
  apiChangeHistory,
  apiChangePassword,
  apiCompleteGuestDetails,
  apiCompleteStaffDetails,
  apiGetInfo,
  apiGetTabs,
  apiLogin,
  apiLoginGG,
  apiLogout,
  apiRefreshToken,
  apiRegister,
  apiUpdateAvatar,
  apiUpdateInfo,
} from './components/urls'

const login = (payload: LoginRequest): Promise<ApiResponse<LoginResponse>> =>
  http.post(apiLogin, payload)
const getInfo = (): Promise<ApiResponse<UserModel & UserExtraInfo>> => http.get(apiGetInfo)
// Bản không che PII, chỉ dùng cho form sửa thông tin cá nhân; không đưa vào store/cache.
const getInfoForEdit = (): Promise<ApiResponse<UserModel & UserExtraInfo>> =>
  http.get('/api/identity/getInfoForEdit')
const refreshToken = (
  refreshToken?: string,
  config?: AxiosRequestConfig
): Promise<ApiResponse<LoginResponse>> =>
  http.post(apiRefreshToken, refreshToken ? { refreshToken } : null, config)
const getTabs = (): Promise<ApiResponse<any>> => http.get(apiGetTabs)

const loginGG = (body: any) => {
  // const params = QueryString.stringify(body)
  // return http.get(`${apiLoginGG}?${params}`)
  const root = window.env?.API_URL || import.meta.env.VITE_REACT_APP_API_ROOT
  const url = `${root}${apiLoginGG}?returnUrl=${body?.returnUrl}`

  return Promise.resolve({
    Object: url,
    isError: false,
  })
}
const changePassword = (payload: any): Promise<ApiResponse<any>> =>
  http.post(apiChangePassword, payload)

const updateInfo = (payload: any): Promise<ApiResponse<any>> => http.post(apiUpdateInfo, payload)
const updateAvatar = (payload: any): Promise<ApiResponse<any>> =>
  http.post(apiUpdateAvatar, payload)
const completeGuestDetails = (payload: any): Promise<ApiResponse<any>> =>
  http.post(apiCompleteGuestDetails, payload)
const completeStaffDetails = (payload: any): Promise<ApiResponse<any>> =>
  http.post(apiCompleteStaffDetails, payload)
const register = (payload: any): any => http.post(apiRegister, payload)
const changeHistory = (payload: any): any => http.post(apiChangeHistory, payload)

const registerInfo = (payload: any): any => {
  if (payload.userType === 'guest') {
    return completeGuestDetails(payload)
  }
  return completeStaffDetails(payload)
}
const logout = () => http.post(apiLogout)

const identityService = {
  login,
  getInfo,
  getInfoForEdit,
  refreshToken,
  getTabs,
  loginGG,
  changePassword,
  updateInfo,
  updateAvatar,
  completeGuestDetails,
  completeStaffDetails,
  register,
  changeHistory,
  registerInfo,
  logout,
}

export default identityService
